export default __webpack_public_path__ + "static/media/G3.37338a15.mp3";